import React from 'react'
import { Route } from 'react-router-dom'
import { RedirectContentEdit } from '../../view/redirect/redirect-content-edit'
import { RedirectContentRoot } from '../../view/redirect/redirect-content-root'
import { RedirectCourseDetails } from '../../view/redirect/redirect-course-details'
import { RedirectImpersonate, RedirectImpersonateRetired } from '../../view/redirect/redirect-impersonate'

export const RouteRedirect = () => {
  return (
    <React.Fragment>
      <Route path="/redirect/content-root/:refreshToken?" component={RedirectContentRoot} />
      <Route path="/redirect/content-edit/:nodeID/:refreshToken?" component={RedirectContentEdit} />
      <Route path="/redirect/course-details/:nodeID/:refreshToken?" component={RedirectCourseDetails} />
      {/* The impersonated tab: a one-time code in the fragment. The old
          /redirect/impersonate/<refreshToken> form opens nothing. */}
      <Route path="/redirect/impersonate" exact component={RedirectImpersonate} />
      <Route path="/redirect/impersonate/:retired" component={RedirectImpersonateRetired} />
    </React.Fragment>
  )
}
